import type { StyleRule } from '@archipro-design/aria';
import { dropdownItemClassName } from '@archipro-design/aria';
import { dropdownItemSlotClassNames } from '@archipro-design/aria';
import { textInputClassName } from '@archipro-design/aria';
import { textInputSlotClassNames } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';
import { inputClassName } from '@archipro-design/aria';
import { inputSlotClassNames } from '@archipro-design/aria';
import { pxArrayToRem } from '@archipro-design/aria';
import { dropdownSlotClassNames } from '@archipro-design/aria';
import { dropdownClassName } from '@archipro-design/aria';
import { svgIconClassName } from '@archipro-design/icons';

export const SuburbSearchInput: StyleRule = ({ theme }) => ({
    ['& .' + dropdownClassName]: {
        width: '100%',
        alignSelf: 'center',
        fontSize: theme.siteVariables.fontSizes['caption02'],
        ['& .' + dropdownSlotClassNames.triggerButton]: {
            fontSize: theme.siteVariables.fontSizes['caption02'],
            alignSelf: 'center',
        },
    },
    ['& .' + inputClassName]: {
        minHeight: pxToRem(50),
        [`& .${inputSlotClassNames.input}.${dropdownClassName}`]: {
            margin: 0,
            [`& .${inputSlotClassNames.input}`]: {
                fontSize: theme.siteVariables.fontSizes['caption02'],
                letterSpacing: 'normal',
            },
            [theme.screen.tablet]: {
                margin: pxArrayToRem([0, 8, 0, 0]),
            },
        },
        [`& .${inputSlotClassNames.icon}`]: {
            minHeight: 'unset',
            height: 'auto',
            [`& .${svgIconClassName}`]: {
                margin: pxArrayToRem([0, 5, 0, 15]),
                [theme.screen.tablet]: {
                    width: pxToRem(24),
                    height: pxToRem(24),

                    margin: theme.siteVariables.spaces['space-8'],
                },
            },
        },
        ['& .' + dropdownSlotClassNames.clearIndicator]: {
            [`& .${svgIconClassName}`]: {
                width: pxToRem(24),
                height: pxToRem(24),
            },
        },
        [`& .${dropdownSlotClassNames.searchInput}`]: {
            padding: pxArrayToRem([0, 8]),
        },
        [`& .${dropdownSlotClassNames.item}`]: {
            border: '0 none',
            [`& .${dropdownItemSlotClassNames.header}`]: {
                fontSize: theme.siteVariables.fontSizes.caption03,
                lineHeight: theme.siteVariables.lineHeightDefault,
            },
        },
    },
    ['& .' + dropdownSlotClassNames.itemsList]: {
        maxWidth: `calc(100vw - ${theme.siteVariables.spaces['space-24']})`,
        ['& .' + dropdownItemClassName]: {
            ['& .' + dropdownItemSlotClassNames.header]: {
                whiteSpace: 'pre-wrap',
                overflow: 'initial',
            },
        },
        [theme.screen.tablet]: {
            maxWidth: pxToRem(504),
        },
    },
    ['& .' + textInputSlotClassNames.primaryContent]: {
        minHeight: pxToRem(50),
        [`& .${textInputSlotClassNames.prefixIcon}`]: {
            minHeight: 'unset',
            height: 'auto',
        },
        [`& .${inputClassName}`]: {
            minHeight: 'unset',
            [`& .${inputClassName}__label`]: {
                maxWidth: pxToRem(200),
                padding: pxArrayToRem([0, 8]),
                alignSelf: 'center',
                marginBottom: theme.siteVariables.spaces['space-4'],
                [theme.screen.tablet]: {
                    marginBottom: 0,
                },
            },
        },
    },
    [`& .${textInputClassName}`]: {
        ['& .' + textInputSlotClassNames.primaryContent]: {
            alignItems: 'center',
            paddingRight: pxToRem(3),
        },
    },
});
